export const environment = {
  name: 'dev',
  production: false,
  restApiBaseUrl: 'https://inspectioncompaniesapi.dev.inspectioncompanies.eu',
  idServer: 'https://id.dev.macadam.eu',
  froalaEditorKey: 'ERB2zF2E1A2B5A2B2B1A5f1ucboCd2ZSb1XHi1Cb2a1KIWCWMJHXCLSwG1G1B2D3B1D7E5E1D4G4==',
  domainName: '.dev.inspectioncompanies.eu',
  azureBlobStorage: 'https://macadam.blob.core.windows.net/'
};
